import { useEffect, useState } from 'react'

/**
 * Detecta si la PWA está corriendo como app instalada (display-mode: standalone).
 *
 * Cobertura:
 *   - Android Chrome / Edge → matchMedia('(display-mode: standalone)').
 *   - iOS Safari            → window.navigator['standalone'] (legacy property).
 *
 * Reactivo: si el modo cambia (raro pero posible al instalar in-session), actualiza el state.
 */
export function useStandaloneMode(): boolean {
  const [isStandalone, setIsStandalone] = useState<boolean>(() => detect())

  useEffect(() => {
    const mq = window.matchMedia('(display-mode: standalone)')
    const handler = () => setIsStandalone(detect())
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [])

  return isStandalone
}

function detect(): boolean {
  if (typeof window === 'undefined') return false
  // Android / desktop
  if (window.matchMedia('(display-mode: standalone)').matches) return true
  // iOS Safari (no estándar)
  const navAny = window.navigator as Navigator & { standalone?: boolean }
  return navAny.standalone === true
}
